import React from 'react';
import FormType from './FormType'
import FormRating from './FormRating'
import ListItem from './ListItem';
import CircularProgress from "@mui/material/CircularProgress"
import './List.css';
import {useState} from 'react'

const List = ({places,load,setRate,width,setType,type,childClick,}) => {
  console.log({childClick})
  console.log({childClick})
  let style = ""; 
  width !== 's' ? 
    style += 'w-full py-4 bg-[#f6f7fc]'
    : 
    style += 'w-full py-4 bg-[#f6f7fc] rounded-t-[30px]'

  return <div className='w-full h-full mx-auto'>
      <div className={style}>
        <h1 className='text-3xl p-4 font-["Open_Sans"] font-bold text-[#f677c0]'>
          Restaurants, Hotels & Attractions <br/> Around You
        </h1>
      <div 
      className='w-full flex flex-row flex-wrap justify-evenly'>
        <FormType 
        type = {type}
        setType = {setType}
        />
        <FormRating 
        setRate={setRate}
        />
      </div>
    </div>
      <div 
      id="style-2"
      className='w-full h-[70vh] bg-[#f6f7fc] overflow-y-auto mx-auto'>
        {!load &&
        <ListItem 
        places = {(places)}
        load = {load}
        childClick = {childClick}
        width = {width}
        />
        }
        {load && (
        <div className="w-full h-2/4 flex flex-col justify-center content-center align-middle items-center">
          <CircularProgress />
        </div>
      )}
      </div>
  </div>
};

export default List;
